import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Memorial from '../views/Memorial.vue'
import Brand from '../views/Brand.vue'
import Shop from '../views/Shop.vue'
import Story from '../views/Story.vue'
import Privacy from '../views/Privacy.vue'
import Legal from '../views/Legal.vue'
import { updateSeo } from '../utils/seo'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      seo: {
        title: '宠物星系｜为每一只毛孩子建立永恒档案',
        description: '宠物星系提供宠物纪念、生命故事记录与数字档案服务，为每一只回到母星的毛孩子建立永恒档案。'
      }
    }
  },
  {
    path: '/memorial',
    name: 'Memorial',
    component: Memorial,
    meta: {
      seo: {
        title: '宠物纪念｜记录与珍藏爱宠的一生｜宠物星系',
        description: '用文字、照片和专属纪念空间记录爱宠的一生，让思念有一个可以回到的地方。'
      }
    }
  },
  {
    path: '/memorial/:category',
    name: 'MemorialCategory',
    component: Memorial,
    meta: {
      seo: {
        title: '宠物纪念空间｜宠物星系',
        description: '为爱宠建立专属纪念空间，保存生命故事、珍贵照片与温暖回忆。'
      }
    }
  },
  {
    path: '/brand',
    name: 'Brand',
    component: Brand,
    meta: {
      seo: {
        title: '关于宠物星系｜用科技温柔保存宠物回忆',
        description: '了解宠物星系的品牌理念与服务愿景：尊重生命，珍藏回忆，让爱以另一种方式一直存在。'
      }
    }
  },
  {
    path: '/shop',
    name: 'Shop',
    component: Shop,
    meta: {
      seo: {
        title: '宠物纪念产品｜宠物星系',
        description: '浏览宠物星系纪念产品，用有温度的物件珍藏与爱宠相伴的时光。'
      }
    }
  },
  {
    path: '/story',
    name: 'Story',
    component: Story,
    meta: {
      seo: {
        title: '宠物故事｜宠物星系',
        description: '阅读宠物星系与宠物家庭的真实故事，感受人与动物之间长久而深厚的爱。'
      }
    }
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy,
    meta: {
      seo: {
        title: '隐私政策｜宠物星系',
        description: '宠物星系隐私政策，说明我们如何收集、使用和保护你的信息。'
      }
    }
  },
  {
    path: '/legal',
    name: 'Legal',
    component: Legal,
    meta: {
      seo: {
        title: '法律声明｜宠物星系',
        description: '宠物星系法律声明与使用条款。'
      }
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    }
    return { top: 0 }
  }
})

router.afterEach((to) => {
  updateSeo(to)
})

export default router
